<template>
  <div class="select-warp">
      <div class="action">
          <div class="fl" @click="cancel">取消</div>
            <span>请选择</span>
          <div class="fr" @click="confirm">确定</div>
      </div>
      <div class="select-warp">
        <div class="indicator"></div>
         <item :list='list' @on-change='change' :show="show"></item>
      </div>
  </div>
</template>


<script>
import Item from './item.vue'

export default {
  components: {
    Item
  },
  methods: {
    change:function(index){
      this.index = index
    },
    cancel: function(){
      // this.$el.removeEventListener('touchmove', handler, false)
      this.$emit('on-cancel')
    },
    confirm: function(){
      // this.$el.removeEventListener('touchmove', handler, false)
      this.$emit('on-confirm', this.index)
    }
  },
  // watch:{

  // },
  // mounted: function(){
  //   this.$el.addEventListener('touchmove', handler, false)
  // },
  props:{
    list:Array
  },
  data(){
    return {
      index: 0,
      show: true
    }
  }
}
</script>

<style lang="stylus">
@import '../../common/styl/global'
  .select-warp
    height rem(282)
    .action
      height rem(44)
      line-height rem(44)
      background #FFF
      font-size rem(14)
      
      text-align center
      color #2B2B2B
      span
        font-weight bold
      .fl
        float left
        padding 0 rem(15)
      .fr
        float right
        padding 0 rem(15)
      .available
        color #808080
    .select__dialog
      position fixed
      bottom 0
      left 0
      width 100%
      z-index 1001
    .select-item-warp
      width 100%
      box-sizing border-box
      float left
      position relative
      height 100%
      overflow hidden
    .select-warp
      position relative
      height rem(238)
      background #FFF
      .mask-top
        position absolute
        top:0
        height rem(102)
        width 100%
        z-index 1
      .mask-bottom
        position absolute
        bottom:0
        height rem(102)
        width 100%
        z-index 1
      .indicator
        position absolute
        top rem(102)
        width 100%
        height rem(34)
        z-index 1
        border-top 1px solid grey
        border-bottom 1px solid grey
        box-sizing border-box

    .scroll-warp
      position absolute
      top:rem(102)
      width 100%
      height rem(34)
      z-index 2
      background rgba(255,255,255,0)
      ul
        list-style none
        margin 0
        padding 0
      li
        box-sizing border-box
        line-height rem(34)
        font-size rem(16)
        text-align center
        white-space nowrap
        overflow hidden
        text-overflow ellipsis

  .select-dialog-enter-active,.select-dialog-leave-active
    height rem(238)

    // opacity 1
    transition-duration 300ms
    // transform translate(-50%, -50%) scale(1)!important
    transition-property height

  .select-dialog-enter, .select-dialog-leave-active
    height 0
    // transform translate(-50%, -50%) scale(1.185)!important
</style>



// WEBPACK FOOTER //
// index.vue?80b4e086